import { useState } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { EllipsisHorizontalIcon, XMarkIcon } from "@heroicons/react/24/outline";

export function MenuEllipsisMobile({ options }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="cursor-pointer" onClick={() => setOpen(true)} href="#">
        <EllipsisHorizontalIcon
          className="w-6 h-auto"
          style={{ cursor: "pointer" }}
        />
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed bottom-0 inset-0 bg-darkBgLight/75 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0">
          <div className="absolute inset-0">
            <div className="pointer-events-none fixed inset-x-0 bottom-0 flex w-screen">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen transform transition duration-500 ease-in-out data-closed:translate-y-full sm:duration-700"
              >
                <div className="flex h-full flex-col bg-white py-6 shadow-xl rounded-t-2xl tracking-tight font-walsheim">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-between">
                      <DialogTitle className="text-grayP">Opciones</DialogTitle>
                      <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          onClick={() => setOpen(false)}
                          className="relative bg-white text-grayP focus:outline-hidden"
                          style={{ cursor: "pointer" }}
                        >
                          <span className="absolute" />
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 grid justify-center gap-4 text-center">
                    {options.map((item, index) => {
                      return (
                        <div key={index}>
                          <a
                            href={item.href}
                            className="group w-full items-center gap-2 py-1 text-center"
                          >
                            {item.text}
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export function MenuEllipsis({ options }) {
  return (
    <Menu>
      <MenuButton href="#">
        <EllipsisHorizontalIcon
          className="w-6 h-auto"
          style={{ cursor: "pointer" }}
        />
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom end"
        className="w-48 origin-top-right font-walsheim tracking-tight rounded-xl text-sm bg-white px-4 py-2 text-tdark transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0"
      >
        <div className="font-bold text-xs text-grayP">Opciones</div>

        {options.map((item, index) => {
          return (
            <MenuItem key={index}>
              <a
                href={item.href}
                className="group flex w-full items-center gap-2 py-1"
                style={{ cursor: "pointer" }}
              >
                {item.text}
              </a>
            </MenuItem>
          );
        })}
      </MenuItems>
    </Menu>
  );
}

export function MenuEllipsisOnClick({ options, principal, onClickAcction }) {
  const filteredOptions = principal
    ? options.filter(
        (item) =>
          item.action !== "deleteAccount" && item.action !== "mainAccount",
      )
    : options;

  return (
    <Menu>
      <MenuButton href="#">
        <EllipsisHorizontalIcon
          className="w-6 h-auto"
          style={{ cursor: "pointer" }}
        />
      </MenuButton>

      <MenuItems
        transition
        anchor="bottom end"
        className="w-48 origin-top-right font-walsheim tracking-tight rounded-xl text-sm bg-darkBgLight px-4 py-2 text-white transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0"
      >
        {filteredOptions.map((item, index) => (
          <MenuItem key={index}>
            <button
              onClick={() => onClickAcction(item.action)}
              className="group flex w-full items-center gap-2 py-1 rounded-md p-2"
              style={{ cursor: "pointer" }}
            >
              {item.text}
              {item.icon}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}

export function MenuEllipsisOnClickMobile({
  options,
  principal,
  onClickAcction,
}) {
  const filteredOptions = principal
    ? options.filter(
        (item) =>
          item.action !== "deleteAccount" && item.action !== "mainAccount",
      )
    : options;
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="cursor-pointer" onClick={() => setOpen(true)} href="#">
        <EllipsisHorizontalIcon
          className="w-6 h-auto"
          style={{ cursor: "pointer" }}
        />
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed bottom-0 inset-0 bg-darkBgLight/75 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
        />

        <div className="fixed inset-x-0">
          <div className="absolute inset-0">
            <div className="pointer-events-none fixed inset-x-0 bottom-0 flex w-screen">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen transform transition duration-500 ease-in-out data-closed:translate-y-full sm:duration-700"
              >
                <div className="flex h-full flex-col bg-darkBgLight py-6 shadow-xl rounded-t-2xl tracking-tight font-walsheim">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-between">
                      <DialogTitle className="text-white">Opciones</DialogTitle>
                      <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          onClick={() => setOpen(false)}
                          className="relative bg-darkBgLight text-white focus:outline-hidden"
                        >
                          <span className="absolute" />
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 grid justify-center gap-4 text-center">
                    {filteredOptions.map((item, index) => {
                      return (
                        <div key={index}>
                          <button
                            type="button"
                            onClick={() => {
                              setOpen(false);
                              onClickAcction(item.action);
                            }}
                            className="group w-full text-white items-center gap-2 py-1 text-center"
                          >
                            {item.text}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
